import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {setSelectedPricePlan, setCurrentPopUp} from '../../TransferOrganizationAccountSlice';
import {PopupEnum, simCardType, DwhActionType, DWHMessageText, DWHStatus, SelectedPackageType} from '../../Constant/Constant';
import {isMobile} from 'react-device-detect';
import {showAppLoader, hideAppLoader} from '../../../../Shared/Loader/LoaderSlice';
import {dwhGeneralReport} from '../../Reports/dwhReports';

const OrgPricePlan = (props) => {
  const slidePerView = 3;
  const [slidesToDisplay, setSlidesToDisplay] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isMobile) {
      showAppLoader();
      var initialState = props.data.pricePlan.slice(0, slidePerView);
      setSlidesToDisplay(initialState);
      hideAppLoader();
    } else {
      setSlidesToDisplay(props.data.pricePlan);
    }

    if (props.data.pricePlan.length === 1) {
      props.setSelectedPricePlan({plan: props.data.pricePlan[0], type: SelectedPackageType.org});
    }

    if (props.data.pricePlan.length > 0) {
      //DWH Report
      let isSim = props.data.simCardType == simCardType.sim;
      dwhGeneralReport({
        data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
        status: DWHStatus.Ongoing,
        messageText: isSim ? DWHMessageText.PackageSIMDisplayed : DWHMessageText.PackageESIMDisplayed,
        actionType: isSim ? DwhActionType.ChoosePackagePageRegularSIM : DwhActionType.ChoosePackagePageESIM,
      });
    }
  }, [props.data.pricePlan]);

  const onSelectedPricePlan = (pricePlan, isMoreInfoSelected) => {
    if (isMoreInfoSelected) {
      props.setSelectedPricePlan({plan: pricePlan, type: SelectedPackageType.org});
      props.setCurrentPopUp(PopupEnum.PricePlanDetailsPopUp);
    } else {
      if (!props.data.selectedPricePlan || pricePlan.plan_code !== props.data.selectedPricePlan?.plan_code) {
        props.setSelectedPricePlan({plan: pricePlan, type: SelectedPackageType.org});
      } else {
        if (props.data.pricePlan.length != 1) {
          props.setSelectedPricePlan(null); //reset
        }
      }
    }
  };

  const handlePrev = () => {
    if (currentIndex === 0) return;
    let prevIndex = currentIndex - 1;
    setCurrentIndex(prevIndex);
    setSlidesToDisplay(props.data.pricePlan.slice(prevIndex, slidePerView + prevIndex));
  };

  const handleNext = () => {
    if (currentIndex === props.data.pricePlan.length - slidePerView) return;
    let nextIndex = currentIndex + 1;
    setCurrentIndex(nextIndex);
    setSlidesToDisplay(props.data.pricePlan.slice(nextIndex, nextIndex + slidePerView));
  };

  return (
    <div>
      {props.data.pricePlan.length > 0 && (
        <>
          <div className='L_Title'>תוכניות ייעודיות לארגון שלך</div>
          <div className='pricePlanContainer'>
            {props.data.pricePlan.length > slidePerView && (
              <Image src={require('../../icons/arrowRight.svg')}
                onClick={() => handlePrev()}
                className={`arrow ${currentIndex === 0 ? 'disable' : ''}`} />
            )}

            {slidesToDisplay.map((pricePlan, i) => (
              <div
                className={`swiper-slide  ${props.data.selectedPricePlan?.plan_code === pricePlan.plan_code ? ' selected ' : ''}`}
                key={i}>
                {pricePlan.plan_code_details_arr && (
                  <div className='package'>
                    <div className='header'>
                      <Image onClick={() => onSelectedPricePlan(pricePlan, false)}
                        className='selectedPackBtn'
                        src={
                          props.data.selectedPricePlan?.plan_code === pricePlan.plan_code
                            ? require('../../icons/radioSelected.svg')
                            : require('../../icons/radio.svg')
                        } />
                      {props.data.selectedPricePlan?.platform_type === 'D' && (
                        <div className='dataBtn'>
                          <Image src={require('../../icons/wifi.svg')} />
                          חבילת דאטה
                        </div>
                      )}
                    </div>
                    <div className='body'>
                      <div className='socDetails'>{pricePlan.soc_business_dtls_desc}</div>
                      <div className='moreDetails' onClick={() => onSelectedPricePlan(pricePlan, true)}>
                        למידע נוסף <Image src={require('../../icons/plus.svg')} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
            {props.data.pricePlan.length > slidePerView && (
              <Image src={require('../../icons/arrowLeft.svg')}
                onClick={() => handleNext()}
                className={`arrow ${currentIndex === props.data.pricePlan.length - slidePerView ? 'disable' : ''}`} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {setSelectedPricePlan, setCurrentPopUp};

export default connect(mapStateToProps, mapDispatchToProps)(OrgPricePlan);
